import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from './DatePicker';
import withTimezone from '../auth/utils/withTimezone';
import moment from 'moment-timezone';

const renderField = (field) => {
  delete field.input.onBlur;
  delete field.input.onFocus;
  const { input, meta, ...props } = field;

  return (
    <div className="u-position-relative">
      <DatePicker
        {...input}
        {...props}
        onChange={(date) => {
          field.input.onChange(date);
        }}
      />
      {field.meta.touched && field.meta.error &&
      <div className="c-input-error-message">{field.meta.error}</div>}
    </div>
  );
};

const DatePickerRedux = ({ ...props }) => (
  <Field
    component={renderField}
    {...props}
    normalize={date => date && moment.tz(date, props.timezone)}
  />
  );

DatePickerRedux.propTypes = {
  name: PropTypes.string.isRequired,
};

export default withTimezone(DatePickerRedux);
